import React from "react";
import {Modal, ModalHeader} from "reactstrap";
import PropTypes from "prop-types";
import Loader from "../../../components/Loader";
import WebHookForm from "./webHookForm";

const WebhookModal = (props) => {
  const {data, open, onCancel} = props;

  return (
    <Modal unmountOnClose={true} isOpen={open} backdrop={"static"}>
      <Loader />
      <ModalHeader>{data && data.id ? "Edit Webhook" : "Add Webhook"}</ModalHeader>
      <WebHookForm data={data} onCancel={onCancel} />
    </Modal>
  );
};

WebhookModal.propTypes = {
  open: PropTypes.bool,
};

export default WebhookModal;
